import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from '@growdash/design-system/molecules';
import { DashboardLayout } from '../../layouts';
// hocs
import AuthGuard from '@hocs/auth-guard';
// auth
import { GROWINTEL_PATHS } from '@growdash/growintel/constants/GrowintelPaths';
import AiPage from '@growdash/growintel/pages/ai';
import RestaurantDetailPage from '@growdash/growintel/pages/branch-detail';
import BrandDetailPage from '@growdash/growintel/pages/brand-detail';
import ComparePage from '@growdash/growintel/pages/compare';
import ProfileView from '@growdash/growintel/pages/profile';
import SearchPage from '@growdash/growintel/pages/search';
import TrendsPage from '@growdash/growintel/pages/trends';
import WatchlistPage from '@growdash/growintel/pages/watchlist';
import { CheckPermission } from '@hocs/check-permission.tsx';
import { RequiredPerm } from '@routes/permissions.ts';

const Page500 = lazy(() => import('@pages/errors/500'));
const Page403 = lazy(() => import('@pages/errors/403'));
const NotFoundPage = lazy(() => import('@pages/errors/404'));

// ----------------------------------------------------------------------

export const growIntelRoutes = [
  {
    path: GROWINTEL_PATHS.ROOT,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: <Navigate to={GROWINTEL_PATHS.TRENDS} replace />
      },
      {
        path: GROWINTEL_PATHS.DETAIL.RESTAURANT,
        hasChildren: true,
        element: <RestaurantDetailPage />
      },
      {
        path: GROWINTEL_PATHS.DETAIL.BRAND,
        hasChildren: true,
        element: <BrandDetailPage />
      },
      {
        path: GROWINTEL_PATHS.TRENDS,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <TrendsPage />
          </CheckPermission>
        )
      },
      {
        path: GROWINTEL_PATHS.COMPARE,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <ComparePage />
          </CheckPermission>
        )
      },
      {
        path: GROWINTEL_PATHS.WATCHLIST,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <WatchlistPage />
          </CheckPermission>
        )
      },
      {
        path: GROWINTEL_PATHS.SEARCH,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <SearchPage />
          </CheckPermission>
        )
      },
      {
        path: GROWINTEL_PATHS.AI,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <AiPage />
          </CheckPermission>
        )
      },
      {
        path: GROWINTEL_PATHS.PROFILE,
        element: (
          <CheckPermission permissionRequired={RequiredPerm?.GrowIntel}>
            <ProfileView />
          </CheckPermission>
        )
      },

      { path: '500', element: <Page500 /> },
      { path: '404', element: <NotFoundPage /> },
      { path: '403', element: <Page403 /> }
    ]
  }
];
